import React, { useState } from "react";

// Contexts
import { useMasteryMap } from "../../context";

// Components
import UnitCard from "../UnitCard";

// Styles
import styles from "./cards.module.scss";

const Cards = () => {
  // Context
  const { units } = useMasteryMap();
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev < units.length - 1 ? prev + 1 : prev));
  };

  const renderCurrentUnit = () => {
    const unit = units[activeIndex];
    if (!unit) return null;
    return <UnitCard key={unit.id} unit={unit} index={activeIndex} />;
  };
  const renderNextUnit = () => {
    const unit = units[activeIndex + 1];
    if (!unit) return null;
    return <UnitCard key={unit.id} unit={unit} index={activeIndex + 1} />;
  };
  const renderPrevUnit = () => {
    const unit = units[activeIndex - 1];
    if (!unit) return null;
    return <UnitCard key={unit.id} unit={unit} index={activeIndex - 1} />;
  };

  return (
    <div className={styles.cardsContainer}>
      <div
        className={styles.cardLeft}
        onClick={handlePrev}
      >
        {renderPrevUnit()}
      </div>

      <div className="flex flex-1">
        {renderCurrentUnit()}
      </div>

      <div
        className={styles.cardRight}
        onClick={handleNext}
      >
        {renderNextUnit()}
      </div>
    </div>
  );
};

export default Cards;
